import gql from 'graphql-tag';

export const refreshIntegrationsQuery = gql`
  query refreshIntegrations {
    #Sidebar
    me {
      integrations {
        id
        title
        type
        broken
        integrationUserId
        features {
          configurable
        }
      }
    }
    #Manage-apps
    integrations {
      type
      title
      setupPath
      image
      imageIcon
      imageProviderIcon
      userConfig {
        instructions
        fields {
          name
          label
        }
      }
      features {
        configurable
      }
    }
  }
`;

export const refreshOrgIntegrationsQuery = gql`
  query refreshOrgIntegrations {
    me {
      organization {
        id
        usage {
          totalIntegrationsCount
          integrations {
            title
            type
            userCount
          }
        }
      }
    }
  }
`;
